import React from 'react';
import PropTypes from 'prop-types';
import CustomHighlight from '../custom-highlight';

function DivisionServiceItem({ hit }) {
    const handleNavigation = (url) => {
        window.history.pushState({}, "", url);
        window.dispatchEvent(new Event("popstate")); // Simulate route change
    };

    return (
        <div className="aa-ItemLink h-100" onClick={() => handleNavigation(hit.url)}>
            <div className="aa-ItemWrapper">
                <div className="aa-ItemContent">
                    <div className="aa-ItemContentBody">
                        <div className="aa-ItemContentTitle">
                            <CustomHighlight attribute="title" hit={hit} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

DivisionServiceItem.propTypes = {
    hit: PropTypes.object.isRequired
};
export default DivisionServiceItem;